export default "__VITE_ASSET__BkrAuakV__"